'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _components = require('../../components');

var _createLoginClient = require('../../helpers/createLoginClient');

var _createLoginClient2 = _interopRequireDefault(_createLoginClient);

var _DefaultString = require('../../helpers/DefaultString');

var _Error = require('../../helpers/Error');

var _ClientError = require('../../helpers/ClientError');

var _Login = require('../../helpers/Login');

var _Login2 = _interopRequireDefault(_Login);

var _Logs = require('../../helpers/Logs');

var _Provider = require('../../helpers/Provider');

var _Router = require('../../helpers/Router');

var _auth = require('../../redux/modules/auth');

var _TopProviders = require('./TopProviders.scss');

var _TopProviders2 = _interopRequireDefault(_TopProviders);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopProviders = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth,
    log: state.log };
}, { startGracePeriod: _auth.startGracePeriod, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(TopProviders, _Component);

  function TopProviders() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TopProviders);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TopProviders.__proto__ || (0, _getPrototypeOf2.default)(TopProviders)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loading: true,
      operatorList: null
    }, _this.onProvider = function (provider) {
      (0, _Provider.navigateToAuthorization)(provider, _this.props.pushState, _this.props.auth, _this.props.startGracePeriod);
    }, _this.navAllProviders = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.AllProviders));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TopProviders, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      (0, _createLoginClient2.default)().then(function (loginClient) {
        return loginClient.operator.getOperatorList({
          languageTag: _this2.props.auth.lang,
          clientId: _this2.props.auth.clientId,
          filter: _Provider.ProviderFilter.TopProvider,
          'original-client-ip': _this2.props.auth.location.ip }, { responseContentType: 'application/json' }).then(function (result) {
          _this2.setState({ operatorList: result.obj.operatorList, loading: false });
        }).catch(function (error) {
          (0, _Error.logError)(error.statusText);
        });
      }).catch(function (error) {
        (0, _ClientError.createLoginClientError)(error, new Error().stack, _this2.props.pushState, _this2.props.auth);
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.startingGracePeriod && !nextProps.auth.startingGracePeriod) {
        if (!nextProps.auth.error) {
          (0, _Login2.default)(nextProps.auth.sessionId, nextProps.auth, this.props.log, this.props.appInfo, this.props.pushState, _Logs.LogEventSelectedOptions.Trial);
        } else {
          (0, _ClientError.createLoginClientError)(this.props.auth.error, new Error().stack, this.props.pushState, this.props.auth);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var providers = this.state.operatorList;

      return _react2.default.createElement(
        'div',
        { className: _TopProviders2.default.topProviders },
        _react2.default.createElement(
          'div',
          { className: _TopProviders2.default.topProvidersContent },
          _react2.default.createElement(
            'div',
            { className: _TopProviders2.default.title },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ProvidersTitle)
          ),
          _react2.default.createElement(
            'div',
            { className: _TopProviders2.default.message },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.TopProvidersMessage)
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          providers ? providers.map(function (provider) {
            var logo = (0, _Provider.getProviderLogo)(provider);
            return _react2.default.createElement(_components.ProviderButton, { key: provider.id, icon: logo, onClick: function onClick() {
                return _this3.onProvider(provider);
              } });
          }) : _react2.default.createElement(_components.LoadingIndicator, { loading: this.state.loading })
        ),
        _react2.default.createElement(_components.BaseButton, { className: _TopProviders2.default.allProviders, onClick: this.navAllProviders, buttonString: _DefaultString.translations.ListAllProviders })
      );
    }
  }]);
  return TopProviders;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  log: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired,
  startGracePeriod: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(TopProviders);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TopProviders/TopProviders.js
// module id = 2025
// module chunks = 0